import React, { useEffect } from "react";
import styled from "styled-components";
import { THEME_COLORS } from "../../../ThemeConfig";

export default function TabbedSelector({
    tabOptions,
    selectedTab,
    setSelectedTab,
}) {
    useEffect(() => {
        setSelectedTab(tabOptions[0].value);
    }, []);

    return (
        <MainBox>
            {tabOptions.map((tabOption) => (
                <TabBox
                    key={tabOption.value}
                    selected={tabOption.value === selectedTab}
                    onClick={() => {
                        setSelectedTab(tabOption.value);
                    }}
                >
                    {tabOption.name}
                </TabBox>
            ))}
        </MainBox>
    );
}
const MainBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 6px;
    gap: 8px;
    background: ${THEME_COLORS.light_100};
    border: 1px solid ${THEME_COLORS.light_300};
    border-radius: 12px;
    width: 100%;
    white-space: nowrap;
    overflow-x: auto;

    -ms-overflow-style: none;
    scrollbar-width: none;

    &::-webkit-scrollbar {
        display: none;
    }

    @media all and (max-width: 480px) {
        width: auto;
        max-width: 100%;
        overflow-x: auto;
    }
`;
const TabBox = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    padding: 8px 16px;
    width: fit-content;
    min-height: 36px;
    box-sizing: border-box;
    font-family: "DM_sans_medium";
    font-size: 14px;
    border-radius: 8px;
    color: ${(props) =>
        props.selected ? THEME_COLORS.white : THEME_COLORS.text_para};
    background: ${(props) =>
        props.selected ? THEME_COLORS.primary : "transparent"};
    border: 2px solid ${(props) =>
        props.selected ? THEME_COLORS.primary : "transparent"};
    transition: background 0.2s, color 0.2s, border-color 0.2s;
    &:hover {
        color: ${(props) =>
            props.selected ? THEME_COLORS.white : THEME_COLORS.primary};
        background: ${(props) =>
            props.selected ? THEME_COLORS.primary : THEME_COLORS.chips_green_container};
        border-color: ${(props) =>
            props.selected ? THEME_COLORS.primary : THEME_COLORS.light_400};
    }
`;
